import { Injectable } from '@angular/core';
import { ResponseModel } from '../../shared/models/response-model.model';
import { StorageService } from '../../shared/services/storage.service';
import { DataService } from '../../shared/services/data.service';
import { tap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DisplayBoardRegistrationService {

   constructor(public service: DataService, public storageService: StorageService) { }
 
   getAllRegistrationListData(data: any) {
     let url = `api/App/DisplayBoardRegistration/getAllDisplayBoardRegistration`;
     return this.service.post(url, data).pipe<ResponseModel>(tap((response: any) => {
       return response;
     })
     );
   }

   updateDisplayBoardRegistrationStatus(data: any) {
    let url = `api/App/DisplayBoardRegistration/updateDisplayBoardRegistrationStatus`;
    return this.service.post(url, data).pipe<ResponseModel>(tap((response: any) => {
      return response;
    })
    );
  }

   deleteDisplayBoardRegistration(id:any){
    let url = `api/App/DisplayBoardRegistration/deleteDisplayBoardRegistration`;
    return this.service.post(url,id).pipe<ResponseModel>(tap((response: any) => {
      return response;
      })
    );
  }
}
